<template>
  <Catalogs
    title="Категории водительских прав"
    create-text="Новая"
    :fetch-data="fetchData"
    :route-create="'DriverLicenseCategoryAdd'"
    :route-edit="'DriverLicenseCategoryEdit'"
    :route-view="'DriverLicenseCategoryView'"
    :route-path="'/driver_license_categories'"
    :can-edit="canEditDriverLicenseCategoryCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import permissions, {PERM} from "../../../utilites/permissions";
import Catalogs from "../Catalogs.vue";

export default {
  name: "DriverLicenseCategories",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getDriverLicenseCategories(data);
    },
    canEditDriverLicenseCategoryCatalogs() {
      return this.hasPermission([PERM.CATALOG_DRIVER_LICENSE_CATEGORY_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/DriverLicenseCategories/DriverLicenseCategories.vue